import { BodyLink, Caption, Chip, theme } from '@kvdbil/components';
import { ChipColor } from '@kvdbil/components/types/components/Chip';
import { responsivePadding } from '@utils/styles';
import { KeyboardEvent, ReactNode } from 'react';
import styled from 'styled-components';

const ItemContainer = styled.div`
  color: ${theme.colors.text.dark};
`;

const Content = styled.div`
  ${responsivePadding};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  column-gap: 0.5rem;

  background-color: ${theme.colors.background.light};
`;

const Footer = styled.div`
  background-color: ${theme.colors.background.light};
  ${responsivePadding}
  display: flex;
  justify-content: left;
  margin-top: 1px;
`;

const Chips = styled.div`
  display: flex;
  gap: 1rem;
  opacity: 1;

  svg {
    font-size: 1rem;
    margin-left: -0.5rem;
  }
`;

interface ChipData {
  label: string;
  color?: ChipColor;
  icon?: ReactNode;
}

interface ItemSectionProps {
  itemId: string;
  title: string;
  subTitle: string;
  chips?: ChipData[];
  onClick?(): void;
}

const ItemCard = ({
  itemId,
  title,
  subTitle,
  onClick,
  chips,
}: ItemSectionProps) => {
  const handleEnter = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Enter') {
      onClick?.();
    }
  };

  return (
    <ItemContainer
      key={itemId}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={handleEnter}
    >
      <Content>
        <BodyLink data-testid="reg-plate">{title}</BodyLink>
        <Caption>{subTitle}</Caption>
      </Content>

      <Footer>
        <Chips>
          {chips?.map((chip, index) => (
            <Chip
              key={index}
              color={chip.color ?? 'neutralLight'}
              prefix={chip.icon}
              size="small"
            >
              {chip.label}
            </Chip>
          ))}
        </Chips>
      </Footer>
    </ItemContainer>
  );
};

export default ItemCard;
